import { IconProp, TagProps } from '@ff-it/ui';
import type { BlockState } from '../block/types';
import { createStateTag } from 'components/StateTag';

export const blockStateVariantMap: Record<
  BlockState,
  {
    icon: IconProp;
    variant: TagProps['variant'];
  }
> = {
  NEW: { icon: 'clock', variant: 'danger' },
  PLANNING: { icon: 'pen-to-square', variant: 'warning' },
  SUBMITTED: { icon: 'clipboard-check', variant: 'warning' },
  APPROVED: { icon: 'play', variant: 'primary' },
  DONE: { icon: 'circle-check', variant: 'success' },
  CANCELED: { icon: 'circle-xmark', variant: 'secondary' },
};

export const BlockStateTag = createStateTag<BlockState>({
  testId: 'block-state-tag',
  stateVariantMap: blockStateVariantMap,
});
